module.exports = __webpack_public_path__ + "fonts/NunitoSans-Italic.9032839.ttf";